import React from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

interface CustomFieldDisplayProps {
  field: {
    name: string;
    type: string;
    mandatory: boolean;
    options?: string[];
  };
}

const CustomFieldDisplay: React.FC<CustomFieldDisplayProps> = ({ field }) => {
  if (field.type === "dropdown") {
    return (
      <FormControl fullWidth size="small" disabled required={field.mandatory}>
        <InputLabel>{field.name}</InputLabel>
        <Select
          label={field.name}
          value=""
          inputProps={{ readOnly: true }}
        >
          {field.options && field.options.length > 0 ? (
            field.options.map((opt: string, idx: number) => (
              <MenuItem key={idx} value={opt}>{opt}</MenuItem>
            ))
          ) : (
            <MenuItem value="" disabled>No options</MenuItem>
          )}
        </Select>
      </FormControl>
    );
  }
  if (field.type === "boolean") {
    return (
      <FormControlLabel
        control={<Checkbox checked={false} disabled />}
        label={field.name}
        sx={{ ml: 1, ...(field.mandatory ? { color: '#B42318' } : {}) }}
        required={field.mandatory}
      />
    );
  }
  return (
    <TextField
      label={field.name}
      placeholder={field.type !== "date" ? `Enter ${field.name}` : undefined}
      type={
        field.type === "date"
          ? "date"
          : field.type === "number"
            ? "number"
            : "text"
      }
      InputLabelProps={{ shrink: field.type === "date" }}
      fullWidth
      size="small"
      required={field.mandatory}
      InputProps={{
        endAdornment: field.type === "date" ? (
          <InputAdornment position="end">
            <CalendarMonthIcon />
          </InputAdornment>
        ) : null,
        readOnly: true
      }}
      sx={{ '& .MuiInputBase-input': { cursor: 'not-allowed' } }}
      disabled
    />
  );
};

export default CustomFieldDisplay;
